import { fmtCFA } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Plus, Minus, Trash2, Banknote, Smartphone, ShoppingCart } from "lucide-react";

export default function CartPanel({ cart, total, disabled, onQty, onRemove, onPay }) {
  return (
    <Card className="bg-card border-border lg:col-span-4 flex flex-col" data-testid="pos-cart">
      <CardHeader className="pb-3">
        <CardTitle className="text-base font-semibold text-foreground flex items-center gap-2">
          <ShoppingCart className="w-4 h-4 text-emerald-600 dark:text-emerald-400" /> Panier
          <Badge variant="outline" className="border-border text-muted-foreground ml-auto" data-testid="cart-count">{cart.length}</Badge>
        </CardTitle>
      </CardHeader>
      <CardContent className="flex-1 flex flex-col">
        <div className="flex-1 space-y-2 max-h-80 overflow-y-auto pr-1">
          {cart.length === 0 && <p className="text-sm text-muted-foreground text-center py-8" data-testid="cart-empty">Le panier est vide</p>}
          {cart.map((i, idx) => (
            <div key={`${i.type}-${i.ref_id || i.nom}-${i.membre_id || ""}`} className="flex items-center gap-2 bg-background border border-border rounded-lg px-3 py-2" data-testid={`cart-item-${idx}`}>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-medium text-foreground truncate">{i.nom}</p>
                {i.membre_nom && <p className="text-[11px] text-muted-foreground truncate" data-testid={`cart-membre-${idx}`}>Membre : {i.membre_nom}</p>}
                <p className="text-xs text-emerald-600 dark:text-emerald-400">{fmtCFA(i.prix)}</p>
              </div>
              <div className="flex items-center gap-1">
                <Button size="icon" variant="ghost" className="h-7 w-7 text-muted-foreground" data-testid={`cart-minus-${idx}`} onClick={() => onQty(idx, -1)}><Minus className="w-3.5 h-3.5" /></Button>
                <span className="text-sm w-6 text-center text-foreground" data-testid={`cart-qty-${idx}`}>{i.quantite}</span>
                <Button size="icon" variant="ghost" className="h-7 w-7 text-muted-foreground" data-testid={`cart-plus-${idx}`} onClick={() => onQty(idx, 1)}><Plus className="w-3.5 h-3.5" /></Button>
                <Button size="icon" variant="ghost" className="h-7 w-7 text-red-600 dark:text-red-400" data-testid={`cart-remove-${idx}`} onClick={() => onRemove(idx)}><Trash2 className="w-3.5 h-3.5" /></Button>
              </div>
            </div>
          ))}
        </div>
        <div className="pt-4 mt-4 border-t border-border space-y-3">
          <div className="flex justify-between items-center">
            <span className="text-sm text-muted-foreground">Total</span>
            <span className="text-xl font-bold text-emerald-600 dark:text-emerald-400" data-testid="cart-total">{fmtCFA(total)}</span>
          </div>
          <div className="grid grid-cols-1 gap-2">
            <Button disabled={disabled} data-testid="pay-especes-button" className="bg-emerald-500 hover:bg-emerald-600 text-white disabled:bg-muted disabled:text-muted-foreground" onClick={() => onPay("especes")}>
              <Banknote className="w-4 h-4 mr-2" /> Espèces
            </Button>
            <div className="grid grid-cols-2 gap-2">
              <Button disabled={disabled} variant="outline" data-testid="pay-wave-button" className="border-sky-500/40 text-sky-600 dark:text-sky-400 hover:bg-sky-500/10" onClick={() => onPay("wave")}>
                <Smartphone className="w-4 h-4 mr-2" /> Wave
              </Button>
              <Button disabled={disabled} variant="outline" data-testid="pay-orange-money-button" className="border-orange-500/40 text-orange-600 dark:text-orange-400 hover:bg-orange-500/10" onClick={() => onPay("orange_money")}>
                <Smartphone className="w-4 h-4 mr-2" /> Orange Money
              </Button>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
